// extracted by mini-css-extract-plugin
export default {"viewItem":"view-form_viewItem__6fVBV","viewItemValue":"view-form_viewItemValue__7MFgI","linkDownload":"view-form_linkDownload__fH7yN"};